  <template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: "App",

  components: {
    // HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
.jsoneditor-vue {
  height: 100% !important;
  min-height: 100vh !important;
}
/* ==============================
    🌙 JSON Editor - Custom Theme
    ============================== */

/* === Struktur dasar editor === */
.jsoneditor,
.jsoneditor-outer,
.jsoneditor-code,
.jsoneditor-tree,
.jsoneditor-tree-inner,
.jsoneditor-mode-code,
.jsoneditor-mode-tree {
  height: 100% !important;
  max-height: 100% !important;
  background-color: #10324e !important;
  color: #00ffff !important;
  border: none !important;
  overflow: hidden !important;
}

/* === Nomor baris (gutter) === */
.ace_gutter {
  background-color: #10324e !important;
  color: #00ffff !important;
}

.ace_gutter-active-line {
  background-color: transparent !important;
}

/* === Area teks utama === */
.ace_editor,
.ace_content,
.ace_text-layer {
  background-color: rgba(15, 35, 70, 0.7) !important;
  color: #e0f7fa !important;
  font-family: "Droid Sans Mono", Consolas, monospace, "Courier New", Courier,
    sans-serif !important;
  font-size: 10pt !important;
}

/* === Cursor (garis kedip) === */
.ace_cursor {
  color: #00ffff !important;
  border-left: 2px solid #00ffff !important;
}

.ace_cursor-layer .ace_cursor {
  animation: blink-cyan 1s step-start infinite;
}

@keyframes blink-cyan {
  50% {
    opacity: 0;
  }
}

/* === Warna teks & syntax === */
.ace_variable,
.ace_identifier {
  color: #4dd0e1 !important; /* key JSON */
}

.ace_string {
  color: #81c784 !important; /* string */
}

.ace_constant.ace_numeric {
  color: #ffcc80 !important; /* number */
}

.ace_constant.ace_language {
  color: #ff8a65 !important; /* boolean/null */
}

.ace_paren,
.ace_punctuation {
  color: #80deea !important; /* braces dan separator */
}

.ace_invalid {
  background-color: #ff5252 !important;
  color: white !important;
}

/* === Baris aktif & selection === */
.ace_marker-layer .ace_active-line,
.ace_marker-layer .ace_selection,
.ace_marker-layer .ace_bracket {
  background-color: transparent !important;
}

/* === Scrollbar === */
.ace_scrollbar,
.ace_scrollbar-inner {
  scrollbar-width: thin !important;
  scrollbar-color: #00ffff rgba(15, 35, 70, 0.7) !important;
}

/* === Mode Switch Button (Code ▾) === */
/* .jsoneditor-modes {
  position: absolute !important;
  top: 8px !important;
  right: 16px !important;
  z-index: 10 !important;
} */

.jsoneditor-separator,
.jsoneditor-type-modes {
  background: rgba(15, 35, 70, 0.9) !important;
  border: 1px solid rgba(0, 255, 255, 0.3) !important;
  color: #00ffff !important;
  font-family: "Droid Sans Mono", monospace !important;
  font-size: 10pt !important;
  border-radius: 0px !important;
}

/* === Context Menu (dropdown mode) === */
.jsoneditor-menu {
  background: rgba(15, 35, 70, 0.9) !important;
  background-color: rgba(15, 35, 70, 0.9) !important;
  border: none;
}

/* === Undo / Redo Button in JSONEditor Menu === */
.jsoneditor-menu > button.jsoneditor-undo,
.jsoneditor-menu > button.jsoneditor-redo {
  color: #00ffff !important;
  fill: #00ffff !important;
  border: none !important;
  background: transparent !important;
  transition: background 0.2s ease, color 0.2s ease;
}

/* Saat hover */
.jsoneditor-menu > button.jsoneditor-undo:hover,
.jsoneditor-menu > button.jsoneditor-redo:hover {
  background: rgba(0, 255, 255, 0.15) !important;
  color: #00ffff !important;
  fill: #00ffff !important;
}

/* Saat disabled */
.jsoneditor-menu > button.jsoneditor-undo:disabled,
.jsoneditor-menu > button.jsoneditor-redo:disabled {
  color: rgba(0, 255, 255, 0.3) !important;
  fill: rgba(0, 255, 255, 0.3) !important;
  opacity: 0.5;
}

/* Target SVG icon di dalam tombol */
.jsoneditor-menu > button.jsoneditor-undo svg,
.jsoneditor-menu > button.jsoneditor-redo svg {
  fill: currentColor !important;
}

.jsoneditor-contextmenu {
  background-color: rgba(15, 35, 70, 0.9) !important;
  border: 1px solid rgba(0, 255, 255, 0.4) !important;
  border-radius: 0px !important;
  padding: 0px !important;
  color: #00ffff !important;
}
div.jsoneditor-contextmenu ul {
  border: none !important;
}

div.jsoneditor-contextmenu ul li button {
  width: 124px;
  height: 24px;
  padding: 0 8px;
  border: none;
  cursor: pointer;
  color: #00ffff !important;
  background-color: rgba(15, 35, 70, 0.9) !important;
  font-size: 10pt;
  font-family: "Droid Sans Mono", monospace !important;
  line-height: 24px;
  text-align: left;
  transition: background 0.2s ease;
}

div.jsoneditor-contextmenu ul li button:hover {
  background: rgba(0, 255, 255, 0.4) !important;
  color: white !important;
}

/* === Error text === */
.jsoneditor-schema-error {
  color: #ff6b6b !important;
  font-weight: 500;
}

/* === Integrasi tema dengan v-card === */
.v-card .jsoneditor {
  background: rgba(15, 35, 70, 0.7) !important;
  border: 1px solid rgba(0, 255, 255, 0.3) !important;
  border-radius: 8px !important;
}

/* === Textarea / field JSON Editor (bukan Ace) === */
div.jsoneditor-field,
div.jsoneditor-value,
div.jsoneditor td,
div.jsoneditor th,
div.jsoneditor textarea {
  font-family: "Droid Sans Mono", Consolas, monospace, "Courier New", Courier,
    sans-serif !important;
  font-size: 10pt !important;
  color: #00ffff !important;
  background-color: rgba(15, 35, 70, 0.5) !important;
}

.v-input--switch__track {
  border: 1px solid #00ffff !important;
  border-radius: 8px;
  width: 36px;
  height: 14px;
  left: 2px;
  position: absolute;
  opacity: 0.6;
  right: 2px;
  top: calc(50% - 7px);
}
/* === Global Custom Scrollbar === */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(
    0,
    234,
    255,
    0.2
  ) !important; /* warna handle scrollbar */
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #00cccc; /* warna saat hover */
}

::-webkit-scrollbar-track {
  background-color: rgba(15, 25, 35, 0.65) !important;
  border-radius: 10px;
}

/* ====== CUSTOM BORDER UNTUK TEXTFIELD TANPA OUTLINED ====== */

/* Warna default garis bawah */
.theme--light.v-text-field > .v-input__control > .v-input__slot::before {
  border-color: rgba(0, 255, 255, 0.4) !important; /* cyan lembut */
  transition: border-color 0.3s ease;
}

/* Warna saat fokus */
.theme--light.v-text-field.v-input--is-focused
  > .v-input__control
  > .v-input__slot::after {
  border-color: #00eaff !important; /* cyan terang */
  box-shadow: 0 0 6px rgba(0, 234, 255, 0.4);
}

/* Untuk mode dark theme (opsional) */
.theme--dark.v-text-field > .v-input__control > .v-input__slot::before {
  border-color: rgba(0, 255, 255, 0.3) !important;
}
.theme--dark.v-text-field.v-input--is-focused
  > .v-input__control
  > .v-input__slot::after {
  border-color: #00ffff !important;
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.5);
}

.leaflet-bar a {
  background-color: #0c203da1 !important;
  border: 1px solid #00ffff !important;
  color: #00ffff !important;
}

.leaflet-touch .leaflet-control-zoom-in,
.leaflet-touch .leaflet-control-zoom-out {
  font-size: 18px !important;
}

.leaflet-container .leaflet-control-attribution {
  background: #0c203da1 !important;
  margin: 0;
}

.leaflet-control-attribution,
.leaflet-control-scale-line {
  padding: 0 5px;
  color: #fff !important;
  line-height: 1.4;
}

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: none !important;
  color: #333;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  padding: 0px;
  width: auto;
  height: auto;
}

/* Atur popup wrapper ketika mode mobile */
.leaflet-popup-content-wrapper.mobile-popup {
  width: 90vw !important;
  max-width: 90vw !important;
  padding: 0 !important;
  border-radius: 16px !important;
}

/* Kontainer content di mobile */
.mobile-popup-content {
  padding: 0 !important;
  max-height: 70vh;
  overflow-y: auto;
}

/* Untuk mencegah leaflet kasih margin default */
.leaflet-popup-content {
  margin: 0 !important;
}

/* Tombol close di mobile */
.mobile-popup-close {
  top: 8px !important;
  right: 8px !important;
  transform: scale(0.9);
}
</style>